const PTGoogleMapsEmbed = ({ value }: IProps) => {
	const { url } = value;

	return (
		<iframe
			src={url}
			title="Google Maps Embed"
			frameBorder="0"
			allow="clipboard-write; geolocation '*'"
			width="640"
			height="480"
			style={{ maxWidth: '100%' }}
			allowFullScreen
		/>
	);
};

interface IProps {
	value: {
		url: string;
	};
}

export default PTGoogleMapsEmbed;
